/**
 * Global "please log in" prompt flag. Two things flip it on:
 *  1. GuestHome's requireAuth (proactive — known guest-gated actions,
 *     e.g. the favourite heart — no wasted round trip).
 *  2. authApiCall (reactive safety net — catches any 401/403 anywhere in
 *     the app, including actions nobody thought to gate explicitly).
 * One flag, one modal (<LoginPromptModal />, mounted once at the app
 * root), fed from two triggers — instead of a modal per screen.
 *
 * Suggested path: coupon-common/src/modules/ui/loginPrompt/index.js
 * (adjust to wherever your other small ducks live, e.g. alongside
 * cities/ or customerCoupons/categories/ — same shape as those).
 */
import { createActions, createReducer } from 'reduxsauce';

const { Types, Creators } = createActions({
  showLoginPrompt: null,
  hideLoginPrompt: null,
});

export { Types };
export const actions = Creators;

const INITIAL_STATE = {
  isOpen: false,
};

const showLoginPrompt = state => ({ ...state, isOpen: true });
const hideLoginPrompt = state => ({ ...state, isOpen: false });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SHOW_LOGIN_PROMPT]: showLoginPrompt,
  [Types.HIDE_LOGIN_PROMPT]: hideLoginPrompt,
});